import { render, staticRenderFns } from "./Createofferimages.vue?vue&type=template&id=264c468e&scoped=true&"
import script from "./Createofferimages.vue?vue&type=script&lang=js&"
export * from "./Createofferimages.vue?vue&type=script&lang=js&"
import style0 from "./Createofferimages.vue?vue&type=style&index=0&id=264c468e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c468e",
  null
  
)

export default component.exports